{
    "12": {
        "type": "zone",
        "key": 12,
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "14": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 14,
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "15": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 15,
        "position": {
            "x": 11,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "16": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 16,
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "17": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 17,
        "position": {
            "x": 12,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "18": {
        "type": "zone",
        "key": 18,
        "position": {
            "x": 10,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "19": {
        "type": "zone",
        "key": 19,
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "20": {
        "type": "zone",
        "key": 20,
        "position": {
            "x": 10,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "21": {
        "type": "zone",
        "key": 21,
        "position": {
            "x": 9,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "22": {
        "type": "zone",
        "key": 22,
        "position": {
            "x": 9,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "23": {
        "type": "zone",
        "key": 23,
        "position": {
            "x": 6,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "24": {
        "type": "zone",
        "key": 24,
        "position": {
            "x": 7,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "25": {
        "type": "zone",
        "key": 25,
        "position": {
            "x": 6,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "26": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 26,
        "position": {
            "x": 12,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "28": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 28,
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "29": {
        "affiliation": "bad",
        "jobKey": "sword",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "key": 29,
        "position": {
            "x": 10,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "41": {
        "type": "zone",
        "key": 41,
        "position": {
            "x": 12,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "42": {
        "type": "zone",
        "key": 42,
        "position": {
            "x": 12,
            "y": 4,
            "z": 1
        },
        "level": 1
    },
    "axeknight": {
        "affiliation": "none",
        "key": "axeknight",
        "position": {
            "x": 10,
            "y": 3,
            "z": 1
        },
        "level": 1
    },
    "archdevil": {
        "affiliation": "bad",
        "bodyKey": "devil",
        "faceKey": "devil",
        "jobKey": "spear",
        "key": "archdevil",
        "maxhealth": 30,
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "level": 1
    }
}
